import React from "react"
import styled from "styled-components"
import { BREAKPOINTS } from "@/styles/themeSettings"
import { getCssSizeValue } from "@/utils/utils"

const BlockQuote = styled.blockquote`
	--size: calc(var(--content-end) - var(--content-start) + 1);
	--l-offset: calc(100% / var(--size) + var(--grid-gap) / 1.25); //dirty but works
	background-color: ${({ theme }) => theme.colors.periwinkle};
	margin: 0 0 0 calc(var(--l-offset, 0) * -1);
	padding: var(--padding) var(--padding) var(--padding) var(--l-offset, var(--padding));
	--padding: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		--padding: ${getCssSizeValue(20, BREAKPOINTS.DESKTOP)};
	}

	p {
		--color: ${({ theme }) => theme.colors.richBlack};
		font-weight: 500;
		font-style: italic;
		font-family: var(--font-borna);
	}
`
const Quote = ({ children }) => {
	return <BlockQuote>{children}</BlockQuote>
}

export default Quote
